/**
 * PostListSkeleton — placeholder cards shown while a feed loads or switches
 * tabs, mirroring the PostCard layout so nothing jumps when posts arrive.
 */
import { Skeleton, SkeletonGroup, skeletonKeys } from '../../components/ui/Skeleton';
import './feed.css';

interface PostListSkeletonProps {
  count?: number;
  /** Announced instead of the generic "Loading...". */
  label?: string;
}

export function PostListSkeleton({ count = 3, label }: PostListSkeletonProps) {
  return (
    <SkeletonGroup className="feed-list" label={label}>
      {skeletonKeys(count).map(key => (
        <article className="post-card post-skeleton" key={key} aria-hidden>
          <div className="post-card__header">
            <Skeleton shape="circle" className="post-skeleton__avatar" />
            <div className="post-skeleton__author">
              <Skeleton className="post-skeleton__line post-skeleton__line--name" />
              <Skeleton className="post-skeleton__line post-skeleton__line--meta" />
            </div>
          </div>
          <div className="post-skeleton__text">
            <Skeleton className="post-skeleton__line" />
            <Skeleton className="post-skeleton__line post-skeleton__line--short" />
          </div>
          <Skeleton shape="rect" className="post-skeleton__media" />
          <div className="post-card__actions">
            <Skeleton className="post-skeleton__action" />
            <Skeleton className="post-skeleton__action" />
            <Skeleton className="post-skeleton__action" />
          </div>
        </article>
      ))}
    </SkeletonGroup>
  );
}
